import { render } from "./BranchSelection.vue?vue&type=template&id=cc15bf5a&scoped=true"
import script from "./BranchSelection.vue?vue&type=script&lang=js"
export * from "./BranchSelection.vue?vue&type=script&lang=js"

import "./BranchSelection.vue?vue&type=style&index=0&id=cc15bf5a&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cc15bf5a"]])

export default __exports__